import { render, staticRenderFns } from "./DerivarFichas.vue?vue&type=template&id=c0354690&"
import script from "./DerivarFichas.vue?vue&type=script&lang=js&"
export * from "./DerivarFichas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports